// Import moment
import moment from 'moment';

export default class DateService {

	private static instance: DateService;

	private constructor() {

	}

	/**
	* Get a singleton instance of StringService.
	*/
	public static getInstance(): DateService {
		if (!DateService.instance) {
			DateService.instance = new DateService();
		}
		return DateService.instance;
	}

	/**
	 * Formats date.
	 * @param date
	 */
	public formatDate(date: Date): string {
		return moment(date).format('MM/DD/YYYY')
	}

	/**
	 * Normalizes the date.
	 * @param date
	 */
	public normalizeDate(date: Date): Date {
		return new Date(date.toString().replace(/-/g, '\/'));
	}
}